'use strict';
angular.module('appMarketplace')
    .directive('feedback', ['NavigationService', 'UrlService', 'NotificationService', 'CommonService', '$compile',
                            '$templateCache', '$http', 'HelpService',
                            function (NavigationService, UrlService, NotificationService, CommonService, $compile,
                                      $templateCache, $http, HelpService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var window;

                function resetItem() {
                    scope.subject = '';
                    scope.comments = '';
                }

                element.on('click', function clickHandler() {
                    if (window && window.element.length) {
                        return;
                    }

                    resetItem();

                    NavigationService.getCurrentAccount(function (currentAccount) {
                        scope.currentAccount = currentAccount;
                        $http.get(UrlService.createAbsoluteUrl('/js/main/directives/templates/feedback-template.html?ver=dd94473cec7c4d1067f4875b352a7c20'), {cache: $templateCache})
                            .then(function successCallback(response) {
                                var templateElement = angular.element(response.data);
                                var windowElement = $compile(templateElement.filter(".feedback-template").html())(scope);
                                var position = {
                                    top: element.offset().top,
                                    left: element.offset().left
                                };
                                window = windowElement.kendoWindow({
                                    title: "Feedback",
                                    width: 350,
                                    maxHeight: 375,
                                    visible: false,
                                    resizable: false,
                                    deactivate: function () {
                                        this.destroy();
                                    }
                                }).data("kendoWindow").openInPosition(position);

                                var formErrorTemplate = kendo.template(templateElement.filter("#feedbackFormErrorTemplate").html());
                                scope.validator = windowElement.kendoValidator({
                                    errorTemplate: formErrorTemplate,
                                    messages: {
                                        required: "Field is required"
                                    }
                                }).data("kendoValidator");

                                scope.sendFeedback = function () {
                                    if (!scope.validator.validate()) {
                                        return;
                                    }
                                    CommonService.showProgressPanel(windowElement, false);

                                    HelpService.sendFeedback({
                                        subject: scope.subject,
                                        comments: scope.comments
                                    }, function feedbackSentSuccessful() {
                                        CommonService.hideProgressPanel(windowElement);
                                        NotificationService.showSuccessMessage('Successfully sent feedback');
                                        window.close();
                                    }, function errorCallback(responseError) {
                                        CommonService.hideProgressPanel(windowElement);
                                        var validationErrors = responseError.validationErrors;
                                        if (validationErrors && Object.keys(validationErrors).length) {
                                            CommonService.displayValidationErrors(validationErrors, formErrorTemplate, windowElement);
                                        } else {
                                            NotificationService.showErrorMessage(responseError.message);
                                        }
                                    });
                                }
                            }, NotificationService.showValidationErrors);
                    });
                });
            }
        };
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/directives/feedback-directive.js
// module id = 199
// module chunks = 17